import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { NavigationContext } from "navigation-react";
import mainLogo from "./images/mainlogo.png";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const DashboardContentHeader = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const username = ls.get("username");
  const logoutToken = ls.get("userlogout_token"); // Must be saved during login

  const handleLogout = async () => {
    try {
      if (!logoutToken) throw new Error("No logout token found");

      const logoutUrl = `${process.env.REACT_APP_BASE_URL}/user/logout?_format=json&token=${logoutToken}`;

      const res = await fetch(logoutUrl, {
        method: "POST",
        credentials: "include", // send session cookie
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok && res.status !== 204) {
        const text = await res.text();
        throw new Error(`Logout failed (status ${res.status}): ${text}`);
      }

      console.log("✅ Logout successful");

      ls.clear(); // Clear stored data
      stateNavigator.navigate("login"); // Redirect to login
    } catch (err) {
      console.error("Logout error:", err);
      ls.clear();
      stateNavigator.navigate("login");
    }
  };

  return (
    <header className="top-menu">
      <div className="logo">
        <img src={mainLogo} alt="Prosep Services Logo" className="logo-image" />
        <h2>Point of Sale</h2>
      </div>
      <nav className="auth-links">
        <ul>
          <li className="authusername">
            <FontAwesomeIcon icon={faUser} />
            {username}
          </li>
          <li className="authlogout">
            <button onClick={handleLogout}>Logout</button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default DashboardContentHeader;
